"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const UiKitLite_1 = require("../UiKitLite");
const react_1 = __importStar(require("react"));
const react_2 = require("@chakra-ui/react");
const Toggle = () => {
    const [isOn1, setIsOn1] = (0, react_1.useState)(true);
    const [isOn2, setIsOn2] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_2.VStack, { align: 'stretch', spacing: UiKitLite_1.UiKitLite.consistency.buffer },
        react_1.default.createElement(react_2.HStack, { align: 'center', spacing: UiKitLite_1.UiKitLite.consistency.buffer },
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Toggle, { isOn: isOn1, onChange: isOn => {
                    setIsOn1(isOn);
                } }),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, isOn1 ? 'I am on' : 'I am off')),
        react_1.default.createElement(react_2.HStack, { align: 'center', spacing: UiKitLite_1.UiKitLite.consistency.buffer },
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Toggle, { isOn: isOn2, onChange: isOn => {
                    setIsOn2(isOn);
                } }),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, isOn2 ? 'I am on' : 'I am off')),
        react_1.default.createElement(react_2.HStack, { align: 'center', spacing: UiKitLite_1.UiKitLite.consistency.buffer },
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Toggle, { isOn: true, isDisabled: true, onChange: () => {
                    // Should never be called
                } }),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "I am a disabled toggle (on)")),
        react_1.default.createElement(react_2.HStack, { align: 'center', spacing: UiKitLite_1.UiKitLite.consistency.buffer },
            react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Toggle, { isOn: false, isDisabled: true, onChange: () => {
                    // Should never be called
                } }),
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "I am a disabled toggle (off)"))));
};
exports.Toggle = Toggle;
